<!-- CONTENUTO -->
<div class="container">
    <div class="row">
      <div class="col-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a appHref="/">{{'HOME' | translate | htmlToText}}</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{'CONFIGURATORE' | translate | htmlToText}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container mb-5">
    <div class="row titolo-pagina">
        <div class="col-12">
          <h1 class="">
            {{'GRADINI_RIENTRANTI' | translate | htmlToText}}
          </h1>
        </div>
      </div>
    <div class="row">

      <div class="col-12 col-md-4 col-lg-3 sidebar-cat" id="sidebar-categoria">
        <div class="row d-none">
          <!-- MOBILE: al click sul seguente bottone si apre l'accordion del configuratore. Alla fine della configurazione smooth scroll su fascia ordinamento e l'accordion rimane aperto. Per modificare scroll in alto.-->
          <div class="col-12 text-center">
            <button class="btn btn-stem w-100 show-hide" (click)="mobileConfiguratoreShow = !mobileConfiguratoreShow">{{'CONFIGURA_IL_TUO_GRADINO' | translate | htmlToText}}</button>
          </div>
          <!-- // -->
        </div>

        <aside class="sidebar-configuratore pt-3 pt-md-0" [class.d-block]="mobileConfiguratoreShow">

          <div class="widget-configuratore mb-5">
            <div class="row mb-3">
              <div class="col-12">
                <h2 class="text-stem text-center text-md-left" style="font-size:1.05rem">{{'CONFIGURATORE' | translate | htmlToText}}</h2>
              </div>
            </div>
            <div class="row mx-0">
              <div class="col-12">
                <app-configuratore *ngIf="strutturaGradinatore" [struttura]="strutturaGradinatore" (risultatiChange)="risultatiChange($event)" (risultatiStaffeChange)="risultatiStaffeChange($event)" [queryParams]="queryParamsGradinatore"></app-configuratore>
              </div>
            </div>
          </div>

          <app-sidebar-preferiti></app-sidebar-preferiti>

        </aside>

      </div>
      <div class="col-md-8 col-lg-9 page-content mt-5 mt-md-0 lista-schede">
        <!-- ORDINAMENTO E NR PRODOTTI -->
        <div class="row ordinamento align-items-center mb-4">
          <div class="col-6 d-none d-md-block">
            <p class="small font-weight-semi-bold mb-0">{{'ITEMS' | translate | htmlToText}} 1-{{schede.length}} {{'OF' | translate | htmlToText}} {{schede.length}}</p>
          </div>
          <div class="col-12 col-md-6 clearfix d-none">
            <form class="form-inline float-right">
              <label class="small font-weight-semi-bold mr-3" for="">Ordinare</label>
              <select class="form-control selectpicker mr-3" id="ordinamento" data-live-search="true">
                    <option data-tokens="indirizzo1">Prezzo</option>
                    <option data-tokens="indirizzo1">Nome</option>
              </select>
              <!-- FRECCIA SU ORDINAMENTO CRESCENTE -->
              <a href="#" class="d-none"><i class="fas fa-arrow-up"></i></a>
              <!-- FRECCIA GIU' ORDINAMENTO DECRESCENTE -->
              <a href="#"><i class="fas fa-arrow-down"></i></a>
            </form>
          </div>

        </div>
        <div class="row product-row">
          <div class="col-6 col-md-4 col-lg-3 mb-5" *ngFor="let scheda of schede">
           <app-card [scheda]="scheda" [showAcquista]="scheda.showAcquista" (aggiungiAlCarrelloClicked)="aggiungiAlCarrello(scheda)"></app-card>
          </div>
        </div>
        <div class="row paginazione align-items-center d-none">
          <div class="col-12 col-md-6">
            <!-- QUANDO SI E' SU PRIMA PAGINA, IL TASTO "PRECEDENTE" E' DISABILITATO -->
            <nav>
              <ul class="pagination">
                <li class="page-item disabled">
                  <a class="page-link " href="#" aria-label="Previous">
                    <span aria-hidden="true"><i class="fas fa-chevron-left"></i></span>
                    <span class="sr-only">Previous</span>
                  </a>
                </li>
                <li class="page-item active"><a class="page-link" href="#">1</a></li>
                <li class="page-item"><a class="page-link" href="#">2</a></li>
                <li class="page-item"><a class="page-link" href="#">3</a></li>
                <li class="page-item">
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
                    <span class="sr-only">Next</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div class="col-12 col-md-6 clearfix d-none">
            <form class="form-inline float-right">
              <label class="small font-weight-semi-bold mr-3" for="">Vedi</label>
              <select class="form-control selectpicker mr-3" id="paginazione" data-live-search="true">
                <!-- MULTIPLI DI 4 -->
                  <option data-tokens="tutti">Tutti</option>
                    <option data-tokens="paginazione1">8</option>
                    <option data-tokens="paginazione2">12</option>
                    <option data-tokens="paginazione3">16</option>

              </select>
              <p class="small font-weight-semi-bold mb-0">prodotti</p>
            </form>
          </div>
        </div>



      </div>
    </div>
  </div>

  <!-- //CONTENUTO -->


  <!-- Modal -->
<div class="modal fade show" [class.d-block]="modalShow" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalShow = false">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{'ATTENZIONE_STAFFA_DA_VERIFICARE' | translate | htmlToText}}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-stem" (click)="this.aggiungiAlCarrello(schedaTempModale, true)">{{'AGGIUNGI_AL_CARRELLO' | translate | htmlToText}}</button>
      </div>
    </div>
  </div>
</div>
